/**
 * The expert search moved into the directory feature. Callers outside the directory still import
 * it from here, and each moves to the feature when its screen is next touched. Delete this file
 * with its last importer.
 */
// eslint-disable-next-line no-restricted-imports -- temporary shim, see the note above
export * from '@/features/directory/api';
